module.exports = __webpack_public_path__ + "img/portfolio-home.66535922.png";